import { HttpClient } from 'shared/libs/http';
import { LoginDto, LoginResponse, SetContextDto, SetContextResponse } from './types';
export class UserApiService {
    public static async setContext(dto: SetContextDto) {
        return await HttpClient.post<SetContextResponse>('/setcontext', dto);
    }

    public static async login(dto: LoginDto) {
        return await HttpClient.post<LoginResponse>('/users/login', dto);
    }

    public static async loginToken() {
        return await HttpClient.post<LoginResponse>('/users/login-token', null);
    }
}
